// src/domains/index.ts —— 组合顺序：shell → 各业务域（modal 合成按 features 顺序合并各域 modal()）
import { broadcast } from './broadcast';
import { home } from './home';
import { prices } from './prices';
import { createShell } from './shell';
import { subs } from './subs';
import { table } from './table';
import type { AgentDomain } from './types';
import { withdraw } from './withdraw';

const features: readonly AgentDomain[] = [home, prices, table, subs, withdraw, broadcast];
export const shell = createShell(() => features);
export const DOMAINS: readonly AgentDomain[] = [shell, ...features];
